import { render } from "./AddAdmin.vue?vue&type=template&id=d7ec357c&scoped=true"
import script from "./AddAdmin.vue?vue&type=script&lang=js"
export * from "./AddAdmin.vue?vue&type=script&lang=js"

import "./AddAdmin.vue?vue&type=style&index=0&id=d7ec357c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d7ec357c"]])

export default __exports__